export default __webpack_public_path__ + "static/media/No_image_available.b65ae615.svg";